
import { defineComponent, PropType } from 'vue'
import { iNodeMetadataField } from '../../../HierarchyManagement'

export default defineComponent({
    name: 'hierarchy-management-hierarchy-master-form',
    components: {},
    props: { nodeGeneralFields: { type: Array as PropType<iNodeMetadataField[]> } },
    data() {
        return {
            fields: [] as iNodeMetadataField[]
        }
    },
    watch: {
        nodeGeneralFields() {
            this.loadFields()
        }
    },
    created() {
        this.loadFields()
    },
    methods: {
        loadFields() {
            this.fields = this.nodeGeneralFields as iNodeMetadataField[]
        }
    }
})
